import { BroadcastifyFeeds } from 'features/broadcastify/components/BroadcastifyFeeds';
import { Flooding } from 'features/flooding/flooding.types';
import { GeoEventLinks } from 'features/geoEvents/components/GeoEventLinks';
import { useReleaseFlag } from 'hooks/useReleaseFlags';

type FloodingStructuredInfoProps = {
  flooding: Flooding;
};

export const FloodingStructuredInfo = (
  props: FloodingStructuredInfoProps,
): JSX.Element => {
  const { flooding } = props;
  const isInternalTabEnabled = useReleaseFlag('internal_tab_on_incidents');

  const links = flooding.data?.links ?? [];
  const internalLinks = flooding.data?.internalLinks ?? [];

  return (
    <>
      {!isInternalTabEnabled && internalLinks.length > 0 && (
        <GeoEventLinks links={internalLinks} internal />
      )}
      {links.length > 0 && <GeoEventLinks links={links} />}
      <BroadcastifyFeeds lat={flooding.lat} lng={flooding.lng} />
    </>
  );
};
